export class InformationsSpecifique {
  id_opp: string;
  json_prod: {};
  inf_prod: [];
  // json_object: {};
  constructor(init?: Partial<InformationsSpecifique>) {
    Object.assign(this, init);
  }
}
